import axios from 'axios'

export const getAllCountriesAsync = async () => {
  const response = await axios.get('Address/GetCountries')
  return response.data
}
